










// TODO: make this better...
import Vue from 'vue';
import fieldsBase from './helpers/fields.base';

export default Vue.extend({
  name: 'switch-component',
  extends: fieldsBase,
  props: ['checked']
});
